<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary"
              id="stockOrderReportSideBar" class="add-new-data-sidebar items-no-padding" spacer v-esc="escape"
              v-model="isActive">
    <new-stock-order ref="newStockOrder" @reload="onReload"/>
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>Stok Siparişleri</h4>
      <feather-icon icon="XIcon" @click.stop="escape" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">
      <vs-row vs-type="flex" vs-w="12" v-if="isActive" class="py-2 px-4">
        <vs-row vs-type="flex" vs-w="12" v-for="order in reportData" :key="order.id" class="my-1">
          <vs-col vs-type="flex" vs-w="7" vs-justify="flex-start" vs-align="center">
            <vs-row vs-type="flex" vs-w="12">
              <vs-row vs-type="flex" vs-w="12">
                <span class="text-dark weight-600 text-xsmaller">
                  {{ order.created }}
                </span>
              </vs-row>
              <vs-row vs-type="flex" vs-w="12">
                <span class="text-dark bold text-small">
                  {{ order.branch.name }}
                </span>
              </vs-row>
              <vs-row vs-type="flex" vs-w="12">
                <span @click="navigateToOrder(order)" class="text-dark weight-600 text-xsmall underline pointer">
                  {{ "#" + order.orderId }}
                </span>
              </vs-row>
            </vs-row>
          </vs-col>
          <vs-col vs-type="flex" vs-w="5" vs-justify="flex-end" vs-align="center">
            <span :class="$getOrderStatusColor(order.status)" class="bold text-xsmall">
              {{ $getOrderStatus(order.status) }}
            </span>
          </vs-col>
          <vs-divider color="dark" class="my-1"/>
        </vs-row>
      </vs-row>
    </VuePerfectScrollbar>
  </vs-sidebar>
</template>

<script>
import NewStockOrder from "@/views/pages/StockOrder/NewStockOrder";
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import {
  getOrderEntries
} from "@/api/StockOrder.js";
export default {
  data() {
    return {
      isActive: false,
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60,
      },
    }
  },
  props: {
    reportData: {
      type: Array,
      required: true
    }
  },
  components: {
    VuePerfectScrollbar,
    NewStockOrder
  },
  methods: {
    onReload() {
      this.$emit("reload")
    },
    navigateToOrder(stockOrder) {
      getOrderEntries(stockOrder.id).then(res => {
        if (res && res.status == 200) {
          this.$refs.newStockOrder.stockOrder = _.cloneDeep(stockOrder);
          this.$refs.newStockOrder.stockOrder.groupes = res.data
          this.$refs.newStockOrder.isPreview = true;
          this.$refs.newStockOrder.isActive = true;
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Sipariş Detayı Getirlemedi !"
          });
        }
      }).catch(() => {
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Sunucu Bağlantı Hatası !"
        });
      })
    },
    escape() {
      if (this.isActive) this.isActive = false;
    }
  },
}

</script>

<style>

</style>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;
  }
}

.tabPager {
  background-color: darkgreen;
  border-radius: 50%;
}

</style>
